import type {
  HubAlgorithmDefinition,
  HubDatapoolArtifact,
} from '@robovision/hub'
import {
  JobBaseArtifact,
  type JobBaseArtifactParams,
} from './JobBaseArtifact'


export interface JobDatapoolArtifactParams extends JobBaseArtifactParams {
  exampleDefinition: string
}

export class JobDatapoolArtifact extends JobBaseArtifact {
  public exampleDefinition: string

  protected constructor (params: JobDatapoolArtifactParams) {
    super(params)
    this.exampleDefinition = params.exampleDefinition
  }

  public static fromDefinition (
    datapoolArtifact: HubDatapoolArtifact,
    algorithmDefinition: HubAlgorithmDefinition,
  ) {
    const datapoolDef = algorithmDefinition.datapoolDefinitions?.find(
      (def) => def.id === datapoolArtifact.datapoolDefinition,
    )

    if (!datapoolDef) {
      throw new Error(
        `Invalid schema. Datapool definition ${datapoolArtifact.datapoolDefinition} not found`,
      )
    }

    return new JobDatapoolArtifact({
      artifactId: datapoolArtifact.id,
      definitionId: datapoolDef.id,
      description: datapoolArtifact.description,
      exampleDefinition: datapoolDef.exampleDefinition,
      name: datapoolArtifact.name,
    })
  }
}
